module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip42-af07f598865adcdeacb943af4699ed03.jpg";